import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';

// Rutas
import { APP_ROUTES } from './app.routes';
// temporal
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Servicios
import { ServiceModule } from './services/service.module';

// Componentes
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './login/register.component';
import { SharedModule } from './shared/shared.module';
import { RecpasswordComponent } from './login/recpassword.component';
import { RegistraModalComponent } from './login/registra-modal.component';
import { ChangepasswordComponent } from './login/changepassword.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { GlobalInterceptor } from './global.interceptor';
//modulos
import { SeguridadComponent } from './modulos/seguridad/seguridad.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { HeaderComponent } from './shared/header/header.component';
import { NgbModule, NgbModalModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MaterialModule } from './material.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CargaMasivaComponent } from './modulos/carga-masiva/carga-masiva.component';
import { MonitoreoComponent } from './modulos/monitoreo/monitoreo.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { BaseChartDirective } from 'ng2-charts';

 //ZONA HORARIA
import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import localesPE from '@angular/common/locales/es-PE'
import { MatPaginatorIntl } from '@angular/material/paginator';
 import { EntradasComponent } from './modulos/entradas/entradas.component';
import { EntradasClienteComponent } from './login/entradascliente.component';
import { ConsultacomprobanteComponent } from './consultacomprobante/consultacomprobante.component';

registerLocaleData(localesPE,'es-Pe');

// Textos de todos los mat-paginator (venian en ingles: "Items per page", "1 - 15 of 482").
export function paginadorEnEspanol(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = 'Registros por página:';
  intl.firstPageLabel = 'Primera página';
  intl.previousPageLabel = 'Página anterior';
  intl.nextPageLabel = 'Página siguiente';
  intl.lastPageLabel = 'Última página';
  intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) return `0 de ${length}`;
    const inicio = page * pageSize;
    return `${inicio + 1} – ${Math.min(inicio + pageSize, length)} de ${length}`;
  };
  return intl;
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    RecpasswordComponent,
    RegistraModalComponent,
    ChangepasswordComponent,
    //modulos
    SeguridadComponent,
    CargaMasivaComponent,
    MonitoreoComponent,
    EntradasComponent,
    EntradasClienteComponent,
    ConsultacomprobanteComponent,

  ],
  exports: [RegistraModalComponent,
    BsDatepickerModule,
    ],
  imports: [
    APP_ROUTES,
    FormsModule,
    ReactiveFormsModule,
    ServiceModule,
    SharedModule,
    NgbModule,
    NgbModalModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    MaterialModule,
    BrowserModule,
    BrowserAnimationsModule,
    BaseChartDirective,
    BsDatepickerModule,
    HttpClientModule,
  ],
  providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: GlobalInterceptor,
        multi: true,

      },
      // { provide: LocationStrategy, useClass: HashLocationStrategy },
      SidebarComponent,
      HeaderComponent,
      { provide:LOCALE_ID,useValue:'es-Pe' },
      { provide: MatPaginatorIntl, useFactory: paginadorEnEspanol },
      provideCharts(withDefaultRegisterables()),
  ],
    bootstrap: [AppComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }
